import { useExamEventDetails } from '@exam-center/exam-event-management';
import {
  ExamEventExamineeStatus,
  FilterOperator,
  useSearchExamEventExamineesWithCertificateStatusAndResultQuery,
} from '@exam-center/graphql';

import { ExamEventExamineeResultDataGrid } from '../../components';
import { type ExamEventExamineeResultListRow } from '../../components/exam-event-examinee-result-data-grid';
import { useExamEventExamineeResultListSearchParams } from '../../hooks';

import { mapExamineeResultData, ORDER_TYPE } from './utils';

export default function ExamEventExamineeResultList() {
  const {
    examEvent: { id: examEventId },
  } = useExamEventDetails();

  const [
    { page, pageSize, sortBy, sortOrder },
    { changePageNumber, changePageSize, changeSorting },
  ] = useExamEventExamineeResultListSearchParams();

  const { data: searchExamineesResult, loading: isSearchExamineesLoading } =
    useSearchExamEventExamineesWithCertificateStatusAndResultQuery({
      variables: {
        searchExamEventExaminees: {
          filter: {
            conditions: [
              {
                field: 'examEventId',
                operator: FilterOperator.Equal,
                value: examEventId,
              },
              {
                field: 'status',
                operator: FilterOperator.In,
                value: [
                  ExamEventExamineeStatus.PendingResults,
                  ExamEventExamineeStatus.Completed,
                  ExamEventExamineeStatus.Absent,
                  ExamEventExamineeStatus.Canceled,
                ],
              },
            ],
          },
          paging: {
            pageSize,
            currentPage: page,
          },
          order: {
            type: ORDER_TYPE[sortOrder],
            field: sortBy,
          },
        },
      },
    });

  const examEventExaminees =
    searchExamineesResult?.ecSearchExamEventExaminees.examEventExaminees ?? [];

  const totalExaminees = searchExamineesResult?.ecSearchExamEventExaminees.total ?? 0;

  const rows: ExamEventExamineeResultListRow[] = examEventExaminees.map(mapExamineeResultData);

  return (
    <ExamEventExamineeResultDataGrid
      rows={rows}
      loading={isSearchExamineesLoading}
      slotProps={{
        footer: {
          total: totalExaminees,
          pagination: {
            page,
            count: totalExaminees,
            rowsPerPage: pageSize,
            onPageChange: (_, page) => {
              changePageNumber(page);
            },
            onRowsPerPageChange: (event) => {
              changePageSize(parseInt(event.target.value));
            },
          },
        },
      }}
      onSortModelChange={(sorting) => {
        const sortModel = sorting[0];
        if (sortModel?.field && sortModel?.sort) {
          return changeSorting({
            sortOrder: sortModel.sort,
            sortBy: sortModel.field,
          });
        }

        return changeSorting({
          sortOrder: null,
          sortBy: null,
        });
      }}
    />
  );
}
